import {has, get} from 'lodash';

interface FieldRules {
  [key: string]: (value: any) => boolean;
}

interface Payload {
  data: {
    attributes: {
      [Property in keyof FieldRules]?: any;
    };
  };
}

export default function makePayloadOmitter(fieldRules: FieldRules) {
  return (payload: Payload) => {
    Object.entries(fieldRules).forEach(([attribute, shouldOmit]) => {
      const path = `data.attributes.${attribute}`;

      if (has(payload, path) && shouldOmit(get(payload, path))) {
        // eslint-disable-next-line no-param-reassign
        delete payload.data.attributes[attribute];
      }
    }, payload);
    return payload;
  };
}
